import { render } from "./claim-config.vue?vue&type=template&id=e1dbb102&lang=pug"
import script from "./claim-config.vue?vue&type=script&lang=js"
export * from "./claim-config.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__